export default "__VITE_ASSET__DT5W5VRt__"